import { ValidationError, useForm } from '@formspree/react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

const Feedback = () => {

  const [state, handleSubmit] = useForm("xayzyeee");
  
  if (state.succeeded) {
    return <div className=" 
    px-2 
    sm:px-4  
    py-2.5
    bg-th-blue-400 
    container 
    flex
    flex-wrap 
    mx-auto">
      <h1 className='text-2xl md:text-4xl text-th-white py-4 w-full'>Thank you for your Feedback!</h1></div>;
  }

  return (
    <div className=" 
    px-2 
    sm:px-4  
    py-2.5
    container 
    flex
    gap-10
    mx-auto">
        <form id="feedback-form" className="w-full lg:w-1/3" onSubmit={handleSubmit}>
          <h1 className='text-2xl md:text-4xl text-th-white py-4 w-full'>Have any questions?</h1>
          <TextField className="bg-th-white rounded w-full mt-4 mb-2" label="Name" id="name" type="name" name="name" variant="outlined" required />
          <TextField className="bg-th-white rounded w-full mt-2 mb-2" label="Email" id="email" type="email" name="email" variant="outlined" required />
          <ValidationError field="email" prefix="Email" errors={state.errors} />
          <TextField className="bg-th-white rounded w-full mt-2 mb-2"
            inputProps={{ maxLength: 500 }}
            multiline
            minRows={5}
            maxRows={10}
            id="message"
            type="message"
            name="message"
            label="Feedback"
            variant="outlined" r
            equired />
          <Button className="bg-th-green hover:bg-th-blue-50 text-th-white rounded mt-2 mb-2" type="submit" disabled={state.submitting} size="large" variant="contained">Submit</Button>
        </form>
    </div>
  );
};

export default Feedback;